import React from 'react'
import ProductImage from './index'

export const LabProductImage = () => {
  return <ProductImage imageSource="/assets/img/app-logo/lab.png" color="#cc4424" />
}
